import insertParagraph from 'containers/SlateEditor/utils/insertParagraph';

function createEmptyLineAfterTitle (editor) {
  insertParagraph(editor);
  insertParagraph(editor);
}

export default createEmptyLineAfterTitle;
